import { render, staticRenderFns } from "./BoardAuditor.vue?vue&type=template&id=155bd888&"
import script from "./BoardAuditor.vue?vue&type=script&lang=js&"
export * from "./BoardAuditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports